import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {softSkillsDataset} from '../../db/models/const'
import {openDialog} from '../../slices/dialog';
import {RadarChartFeedback} from './RadarChartFeedback';
import {selectCv} from '../../slices/profile';
import Button from '../Common/Button';
import {useTranslation} from 'react-i18next';

export const RadarChartExplanation = () => {
    const cv = useSelector(selectCv);
    const softSkills = cv?.softSkills;
    const sorted = Object.entries(softSkills || {}).sort((a, b) => b[1] - a[1], 0);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onFeedback = () => {
        dispatch(openDialog({
            Content: RadarChartFeedback,
            title: "Feedback",
            props: {},
            closable: true
        }));
    }

    return (
        <div className="radarChartExplanation">
            <h2>{t("student_ssExplanation_h3")}</h2>
            <p className="mb10">{t("student_ssExplanation_subtitle")}</p>
            <p className="mb10">
                {t("student_ssExplanation_p1") + " "}
                <span className="highlightOrange">{t("student_ssExplanation_orange")}</span>
                {" " + t("student_ssExplanation_p2")}
                <span className="highlightBlack">{t("student_ssExplanation_black")}</span>
                {" " + t("student_ssExplanation_p3")}
            </p>

            <div className="radarChartExplanation__list">
                {sorted.map((s, i) => <div className="item">
                    <label key={s[0]}>{t(softSkillsDataset[s[0]].label)}</label>
                    <p className="desc pre-wrap">{t(softSkillsDataset[s[0]].description)}</p>
                </div>)}
            </div>
            {softSkills && <div className="feedbackButton">
                <Button onClick={() => onFeedback()}>{t("student_ssExplanation_feedbackbtn")}</Button>
            </div>}
        </div>
    )
}
